import type { OrdersV2 } from '@/api/ordersV2/types';
import { OrderStatusV2Enum } from '@/enums/orderV2';
import ProductCommodity, { MASHANG_COMMODITY } from '@/shared/commodity';
import { Vue, Component, Prop } from 'vue-property-decorator';

const style = require('./index.module.scss') as Dictionary;

const periodUnit: { [key: string]: string } = {
  DAY: '日',
  MONTH: '月',
  YEAR: '年',
};

@Component({ name: 'ApplyContentDetails' })
export default class ApplyContentDetails extends Vue {
  @Prop()
  private orderDetail!: OrdersV2.OrderDetail;

  @Prop()
  private commodityDetail!: OrdersV2.CommodityDetail;

  private get order() {
    return this.orderDetail;
  }

  private get renderInvestors() {
    return (
      this.order
      && this.order.investors
      && this.order.investors
        .map((item) => `${item.name} ${item.rate ? `${(item.rate * 100).toFixed(2)}%` : ''}`)
        .join('|')
    );
  }

  private get isLentOrPayoff() {
    return this.order.state === OrderStatusV2Enum.LENT
    || this.order.state === OrderStatusV2Enum.PAYOFF;
  }

  private get lenTime() {
    return (
      this.order
      && this.order.lentTime
      && this.order.lentTime.replace(/T/g, ' ').split('.')[0]
    );
  }

  /** 是否显示放款机构, 马上渠道不展示放款机构 */
  private get showCommodityName() {
    return (this.commodityDetail && this.commodityDetail.commodityName)
    && String(this.commodityDetail.commodityId) !== MASHANG_COMMODITY
    /** 自营场景不展示放款机构“臻有钱” */
    && String(this.commodityDetail.commodityId) !== ProductCommodity.AUTARKY_B_COMMODITY;
  }

  private render() {
    return (
      <div class={style.ApplyContentDetails}>
        <section class={style.section}>
          {this.order && (this.order.lendFailedMsg || this.order.standardReason) ? (
            <div class={style.content}>
              <span class={style.contentLeft}>失败原因</span>
              <span class={style.contentRight}>{this.order.standardReason ? `${this.order.standardReason}，${this.order.standardSuggestion as string}` : this.order.lendFailedMsg}</span>
            </div>
          ) : null}
          {
            this.order && this.order.amount && this.isLentOrPayoff ? (
              <div class={style.content}>
                <span class={style.contentLeft}>申请金额</span>
                <span class={style.contentRight}>{this.order.applyAmount}</span>
              </div>
            ) : null
          }

          {this.order && this.order.loanOrderId ? (
            <div class={style.content}>
              <span class={style.contentLeft}>提现编号</span>
              <span class={style.contentRight}>{this.order.loanOrderId}</span>
            </div>
          ) : null}

          {this.order && this.order.lentTime ? (
            <div class={style.content}>
              <span class={style.contentLeft}>提现时间</span>
              <span class={style.contentRight}>{this.lenTime}</span>
            </div>
          ) : null}

          {this.showCommodityName ? (
            <div class={style.content}>
              <span class={style.contentLeft}>放款机构</span>
              <span class={style.contentRight}>
                {this.commodityDetail.commodityName}
              </span>
            </div>
          ) : null}

          {this.order
          && this.order.investors
          && this.order.investors.length > 0 ? (
            <div class={style.content}>
              <span class={style.contentLeft}>出资方</span>
              <span class={style.contentRight}>{this.renderInvestors}</span>
            </div>
            ) : null}

          {this.order && this.order.period && this.order.periodUnit ? (
            <div class={style.content}>
              <span class={style.contentLeft}>还款期限</span>
              <span class={style.contentRight}>
                {`${this.order.period}个${periodUnit[this.order.periodUnit]}`}
              </span>
            </div>
          ) : null}

          {this.order && this.order.repaymentModelName ? (
            <div class={style.content}>
              <span class={style.contentLeft}>还款方式</span>
              <span class={style.contentRight}>
                {this.order.repaymentModelName}
              </span>
            </div>
          ) : null}
          {this.order.loanUserBankInfo
          && this.order.loanUserBankInfo.bankName ? (
            <div class={style.content}>
              <span class={style.contentLeft}>收款账户</span>
              <span class={style.contentRight}>
                {`${this.order.loanUserBankInfo.bankName}(${(
                  this.order.loanUserBankInfo
                  && this.order.loanUserBankInfo.cardNo
                  && this.order.loanUserBankInfo.cardNo
                ).substr(-4)})`}
              </span>
            </div>
            ) : null}

          {this.order && this.order.couponName ? (
            <div class={style.content}>
              <span class={style.contentLeft}>优惠券</span>
              <span class={style.contentRight}>{this.order.couponName}</span>
            </div>
          ) : null}
        </section>
      </div>
    );
  }
}
